// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u_t4","buttons":"styles_buttons__2eT1a"};